export default "__VITE_ASSET__CXRm_Tr$__"